import React from "react";
import { ArrowRight, Phone } from "lucide-react";
import { Button } from "./ui/button";
import { COMPANY } from "../mock";

export default function CTA() {
  return (
    <section className="relative py-20 bg-slate-900 overflow-hidden">
      <div className="absolute inset-0 opacity-20">
        <img src="https://images.unsplash.com/photo-1602064828974-fcac67d33f4e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwxfHxpbmR1c3RyaWFsJTIwc2hlZCUyMHJvb2Z8ZW58MHx8fHwxNzc5Nzk1NDcxfDA&ixlib=rb-4.1.0&q=85" alt="" className="w-full h-full object-cover" />
      </div>
      <div className="absolute inset-0 bg-gradient-to-r from-slate-950/90 to-slate-900/60" />
      <div className="relative max-w-7xl mx-auto px-6 grid md:grid-cols-2 gap-10 items-center">
        <div>
          <div className="text-xs font-bold uppercase tracking-[0.25em] text-yellow-600">Ready When You Are</div>
          <h2 className="display mt-3 text-4xl md:text-5xl font-extrabold text-white uppercase leading-tight">
            Have a project? <br />Let’s build it right.
          </h2>
          <p className="mt-5 text-slate-300 max-w-md leading-relaxed">
            From concept to handover, our team is ready to mobilise. Share your scope — we’ll get back within 24 hours with a structured proposal.
          </p>
        </div>
        <div className="flex md:justify-end">
          <div className="flex flex-col sm:flex-row gap-4">
            <a href="#contact">
              <Button size="lg" className="bg-yellow-700 hover:bg-yellow-800 text-white font-semibold h-13 px-7 btn-shine">
                Get a Quote <ArrowRight className="w-4 h-4 ml-2" />
              </Button>
            </a>
            <a href={`tel:${COMPANY.phone.replace(/\s+/g, "")}`}>
              <Button size="lg" variant="outline" className="border-white/40 text-white bg-white/5 hover:bg-white hover:text-slate-900 font-semibold h-13 px-7">
                <Phone className="w-4 h-4 mr-2" /> {COMPANY.phone}
              </Button>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
